import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { smsTypesDataSource } from 'infrastructure/data-sources/sms-types';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { ISmsTypeItem } from 'infrastructure/data-sources/sms-types';

type Options = IBaseSelectBoxOption<ISmsTypeItem['id'], ISmsTypeItem>[];

interface IProps
  extends Omit<IBaseSelectBoxProps<ISmsTypeItem['id']>, 'options'> {
  withAll?: boolean;
}

const SmsTypeSelectBox: React.FC<IProps> = (props) => {
  const { withAll } = props;
  const dataSource = useMemo(() => smsTypesDataSource({ withAll }), [withAll]);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default SmsTypeSelectBox;
